export default __webpack_public_path__ + "assets/img/ict-marker.4a344efeda7a62f36b366f0f8f2e260e.svg";